import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import PatientPortalShell from '@/modules/referral/components/PatientPortalShell';
import PublicBookingSection from '@/components/PublicBookingSection';
import { useTenant } from '@/contexts/TenantContext';
import { DEFAULT_TENANT_SLUG } from '@/config/singleTenant';
import { IITH, SERIF, SANS } from '@/pages/landing/iithBrand';
import { patientPortalApi } from '../api/patientPortal.api';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/** Book OPD inside patient portal — navy panel matches public landing contrast. */
export default function PatientBookAppointmentPage() {
  const { tenant } = useTenant();
  const slug = tenant?.slug || DEFAULT_TENANT_SLUG;
  const primary = tenant?.branding?.primary_color || IITH.saffron;
  const [doctors, setDoctors] = useState([]);
  const [home, setHome] = useState(null);

  useEffect(() => {
    patientPortalApi.home().then(setHome).catch(() => setHome(null));
  }, []);

  useEffect(() => {
    if (!slug) return undefined;
    axios.get(`${API}/api/tenant/${slug}/doctors`)
      .then(({ data }) => setDoctors(Array.isArray(data) ? data : (data?.doctors || data?.items || [])))
      .catch(() => setDoctors([]));
    return undefined;
  }, [slug]);

  const isFacultyStaff = Boolean(home?.is_faculty_staff);
  const allowedCategories = isFacultyStaff
    ? ['self', 'dependent', 'non_dependent']
    : ['self'];
  const prefillPatient = home ? {
    id: home.patient?.id || '',
    name: home.patient?.name || home.user?.name || '',
    email: home.user?.email || '',
    phone: home.patient?.phone || '',
    age: home.patient?.age,
    gender: home.patient?.gender || '',
  } : null;
  const familyMembers = home?.family || [];

  return (
    <PatientPortalShell wide>
      <div className="mb-5">
        <p className="text-[11px] uppercase tracking-[0.22em]" style={{ color: IITH.gold, fontFamily: SANS }}>
          Appointments
        </p>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#071B34] mt-1" style={{ fontFamily: SERIF }}>
          Book an appointment
        </h1>
        <p className="text-sm text-[#5A6B7C] mt-1 max-w-xl">
          {isFacultyStaff
            ? 'Reserve a campus OPD slot for yourself, a dependent, or a non-dependent guest.'
            : 'Reserve a campus OPD slot for yourself and track your visits.'}
        </p>
      </div>
      {!slug || !home ? (
        <div className="py-12 text-center"><Loader2 className="h-7 w-7 animate-spin mx-auto text-[#F15A22]" /></div>
      ) : (
        <div
          className="rounded-3xl overflow-hidden shadow-lg border border-[#0C2744]"
          style={{ background: IITH.navy }}
          data-testid="patient-book"
        >
          <div className="p-4 sm:p-6">
            <PublicBookingSection
              slug={slug}
              primary={primary}
              doctorProfiles={doctors}
              initialIntent="consulting"
              lockIntent
              skipEmailOtp
              allowedCategories={allowedCategories}
              prefillPatient={prefillPatient}
              familyMembers={familyMembers}
            />
          </div>
        </div>
      )}
    </PatientPortalShell>
  );
}
